export const handleFileUploadChange = ({ file, setFile, fieldName, setUpdatedFormFields, }) => {
    if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
            try {
                const result = reader.result;
                if (typeof result === 'string') {
                    setFile(result);
                }
            }
            catch (error) {
                // TODO handle reader error
            }
        };
        reader.readAsDataURL(file);
    }
    else {
        setFile(file);
    }
    if (setUpdatedFormFields) {
        setUpdatedFormFields((prev) => {
            const newSet = new Set(prev);
            newSet.add(fieldName);
            return newSet;
        });
    }
};
export const getFlatTranslations = ({ translations, fieldName, }) => {
    return Object.fromEntries(Object.entries(translations).map(([lang, value]) => [
        `${fieldName}${lang.toUpperCase()}`,
        value,
    ]));
};
export const validateRallyFormUpdatedFormFields = ({ updatedFormFields, validateInputField, validateSelect, formState, customInputValidationSchema, }) => {
    let updatedFieldsHasErrors = false;
    if (updatedFormFields.has('internalTitle')) {
        const error = validateInputField({
            fieldName: 'internalTitle',
            value: formState.internalTitle,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('titleDE')) {
        const error = validateInputField({
            fieldName: 'titleDE',
            value: formState.titleTranslations.de,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('titleEN')) {
        const error = validateInputField({
            fieldName: 'titleEN',
            value: formState.titleTranslations.en,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('titleCS')) {
        const error = validateInputField({
            fieldName: 'titleCS',
            value: formState.titleTranslations.cs,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('descriptionDE')) {
        const error = validateInputField({
            fieldName: 'descriptionDE',
            value: formState.descriptionTranslations.de,
            customInputSchema: customInputValidationSchema,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('descriptionEN')) {
        const error = validateInputField({
            fieldName: 'descriptionEN',
            value: formState.descriptionTranslations.en,
            customInputSchema: customInputValidationSchema,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('descriptionCS')) {
        const error = validateInputField({
            fieldName: 'descriptionCS',
            value: formState.descriptionTranslations.cs,
            customInputSchema: customInputValidationSchema,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('minutes')) {
        const error = validateInputField({ fieldName: 'minutes', value: formState.minutes });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('isRallyTimeLimit')) {
        if (formState.isRallyTimeLimit) {
            const error = validateInputField({ fieldName: 'minutes', value: formState.minutes });
            if (error) {
                updatedFieldsHasErrors = true;
            }
        }
    }
    if (updatedFormFields.has('selectedThemes')) {
        const error = validateSelect('themes', !!formState.selectedThemes.length);
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('selectedTargetGroups')) {
        const error = validateSelect('targetGroups', !!formState.selectedTargetGroups.length);
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    return updatedFieldsHasErrors;
};
